<template>
  <footer class="relative">
    <div class="grid container mx-auto justify-between">
      <!-- menu render -->
      <div class="menu w-max flex-shrink-[1]">
        <div v-for="menuItem in menu" :key="menuItem.name" class="text-left max-md:text-center">
          <ul>
            <li v-for="item in menuItem.list" :key="item.title">
              <component
                :is="item.tag"
                v-bind:[item.attribute]="item.link"
                class="text-left text-gray-400 font-normal transition-colors hover:text-gray-100 text-xs"
              >
                {{ item.title }}
              </component>
            </li>
          </ul>
        </div>
      </div>

      <!-- logo render -->
      <div class="grid-logo flex flex-col w-max flex-shrink-[2]">
        <div class="flex flex-row">
          <router-link class="logo h-auto relative" to="/">
            <img
              class="logo-image my-auto"
              src="../../assets/img/LR_logo2.svg"
              alt="Logo"
              style="width:2.4375rem; height: 2.625rem"
            />
            <span class="logo-title leading-5 italic">LIVE RUSSIA</span>
          </router-link>
        </div>
      </div>

      <!-- payments render -->
      <div class="payments-options flex w-max justify-center">
        <div class="payment-content flex flex-col gap-3">
          <div class="payment-icons">
            <router-link
              to="/donate"
              v-for="({ img, alt }) in items"
              :key="alt"
              class="payment-method"
            >
              <img :src="img" :alt="alt" class="payment-icon" />
            </router-link>
          </div>
          <a href="mailto:admin@liverussia.online" class="font-normal self-center text-gray-400 text-xs hover:text-gray-100 text-left flex">
            ADMIN@LIVERUSSIA.ONLINE
          </a>
          <Social class="footer-social" />
        </div>
      </div>

      <!-- info render -->
      <div class="info flex w-max">
        <div v-for="menuItem in info" :key="menuItem.name" class="text-right max-md:text-center">
          <ul>
            <li v-for="item in menuItem.list" :key="item.title">
              <component
                :is="item.tag"
                v-bind:[item.attribute]="item.link"
                class="text-gray-400 font-normal transition-colors hover:text-gray-100 text-xs"
              >
                {{ item.title }}
              </component>
            </li>
            <!-- <li class="mt-1">
              <span class="text-gray-400 font-normal transition-colors hover:text-gray-100 text-xs">
                <div>{{ t('footer_organization_name') }}</div>
                <div>{{ t('footer_organization_about') }}</div>
              </span>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Social from '../Social.vue'

const { t, locale } = useI18n()

const isCIS = computed(() => ['ru', 'kk'].includes(locale.value))

const menu = computed(() => [
  {
    name: t('footer_menu_title'),
    list: [
      { title: 'Wiki', link: 'https://wiki.liverussia.online', tag: 'a', attribute: 'href' },
      {
        title: t('footer_forum'),
        link: '//forum.liverussia.online/index.php',
        tag: 'a',
        attribute: 'href'
      },
      { title: t('footer_partner'), link: '//partner.liverussia.online', tag: 'a', attribute: 'href' },
      { title: t('header_recovery'), link: '/recovery', tag: 'router-link', attribute: 'to' }
    ]
  }
])

const info = computed(() => [
  {
    name: t('footer_info_title'),
    list: [
      { title: t('contacts_title'), link: '/contacts', tag: 'router-link', attribute: 'to' },
      {
        title: isCIS.value ? t('footer_offer') : t('footer_terms_of_use'),
        link: '/agreement',
        tag: 'router-link',
        attribute: 'to'
      },
      { title: t('footer_privacy'), link: '/privacy', tag: 'router-link', attribute: 'to' },
      { title: t('account_deletion.link'), link: '/account-deletion', tag: 'router-link', attribute: 'to' }
    ]
  }
])

const items = ref([
  {
    img: require('@/assets/img/mir.svg'),
    alt: 'МИР'
  },
  {
    img: require('@/assets/img/mastercard.svg'),
    alt: 'Mastercard'
  },
  {
    img: require('@/assets/img/sbp.svg'),
    alt: 'СБП'
  },
  {
    img: require('@/assets/img/visa.svg'),
    alt: 'Visa'
  }
])
</script>

<style scoped>
footer {
  flex-shrink: 0;
  padding-block: clamp(32px, 4vw, 64px) 32px;
  background-color: #00092e;
  @apply z-[9999];
}

div.grid {
  width: min(var(--footer-width), calc(100% - 32px));
  max-width: none;
  @apply grid-cols-6 max-md:gap-5 mx-auto;
}

.grid-logo {
  @apply col-span-1 col-start-2 max-md:col-start-1 max-md:col-span-6 max-md:items-center max-md:justify-self-center max-md:row-start-2;
}

.footer-social {
  width: auto;
  justify-content: center;
  align-self: center;
  gap: 0.5rem;
}

.payment-content { width: 100%; }
.payment-icons { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); align-items: center; gap: 6px; }
.payment-method { display: flex; align-items: center; border-radius: 5px; }
.payment-icon { display: block; width: 100%; height: auto; transition: filter 150ms; }
.payment-method:hover .payment-icon,
.payment-method:focus-visible .payment-icon { filter: brightness(1.25) drop-shadow(0 0 6px #97bbf066); }
.payment-method:focus-visible { outline: 2px solid #97bbf0; outline-offset: 3px; }

.payments-options {
  width: 100%;
  max-width: 290px;
  min-width: 0;
  @apply col-span-2 col-start-3 justify-self-center max-md:col-start-1 max-md:col-span-6 max-md:items-center max-md:justify-self-center max-md:row-start-3;
}

.menu {
  @apply col-span-1 row-span-1 row-start-1 max-md:col-start-1 max-md:col-span-6 max-md:items-center max-md:justify-self-center max-md:row-start-1;
}

.info {
  @apply col-span-2 col-start-5 justify-self-end max-md:col-start-1 max-md:col-span-6 max-md:items-center max-md:justify-self-center max-md:row-start-4;
}

.menu,
.info,
.contacts {
  @apply flex flex-col;
}
</style>
